export const rteErrorReviewPageTranslations = {
  en: {
    rteErrorReviewPage: {
      edit: 'Edit',
      rteCannotAddCardHeader:
        "We weren't able to add this insurance card. Please select an option below to continue.",
      rteInactiveErrorDescription:
        'We found your insurance coverage, but it is no longer active. To add insurance please upload a different card. Or you can review your insurance card at your appointment.',
      rteInactiveErrorTitle: 'Coverage not active',
    },
  },
  es: {
    rteErrorReviewPage: {
      edit: 'Editar',
      rteCannotAddCardHeader:
        'No pudimos agregar esta tarjeta de seguro. Seleccione una de las siguientes opciones para continuar.',
      rteInactiveErrorDescription:
        'Encontramos su cobertura de seguro, pero ya no está activa. Para agregar seguro, cargue una tarjeta diferente. O puede revisar su tarjeta de seguro en su cita.',
      rteInactiveErrorTitle: 'Cobertura no activa',
    },
  },
};

export const processingTranslations = {
  en: {
    processing: {
      birthDate: 'Birth date',
      employmentStatus: 'Employment status',
      processingCard: 'Reading card information...',
      success: 'success',
      processingTakesAWhile:
        'Card processing may take up to 10 seconds to complete.',
      verificationSuccess: 'Verification success',
      verificationSuccessful: 'Verification successful',
      verifyingInsurance: 'Verifying insurance',
    },
  },
  es: {
    processing: {
      birthDate: 'Fecha de nacimiento',
      employmentStatus: 'Estado laboral',
      processingCard: 'Leyendo la información de la tarjeta...',
      success: 'éxito',
      processingTakesAWhile:
        'El procesamiento de la tarjeta puede tardar hasta 10 segundos en completarse.',
      verificationSuccess: 'Éxito de la verificación',
      verificationSuccessful: 'Verificación exitosa',
      verifyingInsurance: 'Verificando seguro',
    },
  },
};
